
import React, { FC, useContext, useEffect } from "react";
import "./FallBackComponent.scss";

import ThemeContext, { themes } from "../../ThemeContext";
import { detectBase64ImageType } from "../commonFunctions";

interface FallbackProps {
    backColor?: boolean;
    height?: number
}
const FallBackComponent: FC<FallbackProps> = ({ backColor, height }) => {
    //const windowHeight = useRef(document.);

    const themes = useContext(ThemeContext);
    //background-color:rgba(0 , 0 , 0 , .5);

    useEffect(() => {

        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "auto";
        }
    }, [])



  


    return (
        <>
            <div className="fallback-container" style={{ height: `${height}px`, backgroundColor: backColor ? "transparent" : "rgba(0 , 0 , 0 , .5)" }}>
                <div className="fallback-elements">
                    {/*  <div className="spin ">
                    </div> */}
                    {/*  <img src={themes.name === 'MUME' ? mume : EdfaLoading} alt="logo" /> */}
                    <img src={detectBase64ImageType(themes?.loaderImage)} alt="" />
                </div>
            </div>
        </>

    )
}

export default FallBackComponent; 